import { useMemo, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ActionModuleInstanceResponse } from "../../../../../types/actionModule/instance/actionModuleInstance";
import { BaseModuleSubtype } from "../../../../../types/actionModule/subtypes/subtype";
import { GeneralButton } from "../../../../../common/ui/GeneralButton";
import { ActionModule } from "../../../../../types/actionModule/actionModule";
import { subtypes } from "../../../../../types/actionModule/actionModuleTypes";
import { BaseSubtypeDataModel } from "../../../../../types/actionModule/instance/subtypeData";

interface Props {
    actionModule: ActionModule;
    instance: ActionModuleInstanceResponse;
}

export default function InstanceSubtypeDetailsCell(props: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);

    return <>
        {
            props.instance.subtypeData.length > 0 &&
            <IconButton onClick={() => setDialogOpen(true)}>
                <InfoOutlined />
            </IconButton>
        }

        <InstanceSubtypeDetailsDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            {...props} />
    </>
}

interface InstanceSubtypeDetailsDialogProps extends Props {
    open: boolean;
    onClose: () => void;
}

function InstanceSubtypeDetailsDialog(props: InstanceSubtypeDetailsDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            fullWidth
            maxWidth="lg">
            <DialogTitle>{t("incentivationPage.instanceDetailsTitle")}</DialogTitle>
            <DialogContent>
                {
                    props.actionModule.subtypes.map(s => <>
                        {s.name && <Typography variant="subtitle1">{s.name}</Typography>}
                        <SubtypeDetails
                            key={s.id}
                            actionModule={props.actionModule} subtype={s}
                            instance={props.instance} />
                    </>)
                }
            </DialogContent>
            <DialogActions>
                <GeneralButton
                    onClick={props.onClose}
                >
                    {t("buttons.ok")}
                </GeneralButton>
            </DialogActions>
        </Dialog>
    );
}

interface SubtypeDetailsProps {
    actionModule: ActionModule;
    subtype: BaseModuleSubtype;
    instance: ActionModuleInstanceResponse;
}

export interface SubtypeDataViewProps {
    subtype: BaseModuleSubtype;
    subtypeData: BaseSubtypeDataModel;
}

function SubtypeDetails(props: SubtypeDetailsProps) {
    const subtypeData = useMemo(
        () => props.instance.subtypeData.find(d => d.moduleSubtypeId === props.subtype.id),
        [props.instance, props.subtype]
    );

    const subtypeDefinition = useMemo(
        () => subtypes.find((s) => s.type === props.subtype.subtype),
        [props.subtype.subtype]
    )

    if (subtypeData === undefined) {
        return <></>;
    }
    if(!subtypeDefinition) {
        return <></>;
    }
    if(!subtypeDefinition.subtypeDataView) {
        return <></>;
    }

    return subtypeDefinition.subtypeDataView({
        subtype: props.subtype,
        subtypeData: subtypeData,
    });
}
